import React from 'react'
import { Card, Icon, Image, Label, Button, Popup } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import avatar from "./../../../../../images/common/jenny.jpg";
import { source } from 'react-aim';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import noInvite from './../../../../../images/grafix-banner/undraw_hire.svg';
import camelCaseCovert from './../../../../../helpers/convert-camel-case';
import ImageAvater from './../../../../drive/Components/ImageAvater';
import RemoveUserFromWorkspace from "../modals/RemoveUserFromWorkspace";
import DeleteUserFromUnit from "../modals/DeleteUserFromUnit";
import { toastr } from 'react-redux-toastr';

let timer = 0;
let delay = 200;
let prevent = false;
const _ = require('lodash');

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name);
    }
})

class UsersList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }

        this.getInvitationStatus = this.getInvitationStatus.bind(this);
    }

    componentWillMount() {
        dispatch.lifeCycle.setLibraryCardIndex(null);
        dispatch.organizationUnit.showDeleteDisabled(false)
    }

    getInvitationStatus = function (invitation) {
        if (invitation.isDeclined) {
            return "Declined";
        }
        if (invitation.isAccepted) {
            return "Accepted";
        }
        return "Pending";
    }

    redirectUserInvite() {
        const { history } = this.props;
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/addUser/addUserInUserGrid/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${this.props.selectedSubOrg && this.props.selectedSubOrg.parentOrganizationId ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
    }

    handleClick(user, index) {
        let thisClick = this;
        timer = setTimeout(function () {
            if (!prevent) {
                thisClick.cardClick(user, index);
            }
            prevent = false;
        }, delay);
    }

    async cardClick(user, index) {
        if (this.props.match.params.userType === 'Invitations') {
            dispatch.organizationUnit.showResourecePane("Invited");
            dispatch.invite.updateStateForResource(user);
            dispatch.lifeCycle.splitAt("60%")
            dispatch.lifeCycle.setLibraryCardIndex(index)
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            dispatch.users.userDeactivateModal(false);
            dispatch.organizationUnit.showDeleteDisabled(true);
        }
        else {
            dispatch.users.updateState(user);
            dispatch.community.addMainAreaContext('USERS');
            dispatch.organizationUnit.showResourecePane("User");
            if (this.props.match.params.teamId.toString() === this.props.selectedOrganisation.id.toString()) {
                const userRoleArray = this.props.selectedOrganisation.users.filter(function (user) {
                    return (user.role === 'workspaceOwner');
                });

                if ((this.props.user._id.toString() === user._id.toString() || (userRoleArray.length < 2 && user.role === 'workspaceOwner') || this.props.selectedOrganisation.role !== 'workspaceOwner')&& (this.props.user._id === user._id  )) {
                    dispatch.organizationUnit.showDeleteDisabled(false);
                }
                else {
                    dispatch.organizationUnit.showDeleteDisabled(true);
                }
            }
            else {
                const userRoleArray = this.props.selectedSubOrg.members.filter(function (user) {
                    return (user.role === 'Manager');
                });

                if (userRoleArray.length < 2 && user.role === 'Manager') {
                    dispatch.organizationUnit.showDeleteDisabled(false);
                }
                else {
                    dispatch.organizationUnit.showDeleteDisabled(true);
                }
            }
            dispatch.lifeCycle.splitAt("60%")
            dispatch.lifeCycle.setLibraryCardIndex(index)
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            dispatch.users.userDeactivateModal(false);
        }
    }

    handleDoubleClick(user, index) {
        clearTimeout(timer);
        prevent = true;
        this.doDoubleClickAction(user, index);
    }

    doDoubleClickAction(user, index) {
        this.cardClick(user, index);
        dispatch.lifeCycle.splitAt("60%");
    }

    removeUser = async (user,index) => {
        dispatch.users.updateState(user);
        if (this.props.orgUniqueId.toString() === this.props.selectedOrganisation.id.toString()) {
            let payload = {};
            payload.accountUserId = user._id;
            payload.organisationId = this.props.selectedOrganisation.id;
            payload.subOrgId = this.props.orgUniqueId;
            dispatch.users.getdeactivateuserdetails(payload)
            dispatch.users.userDeactivateModal(true);
        } else {
            let deletesuborgObj = Object.assign({}, user);
            deletesuborgObj.role = user.role;
            deletesuborgObj.subOrgName = this.props.selectedSubOrg.name;
            deletesuborgObj.subOrgId = this.props.selectedSubOrg._id;
            deletesuborgObj.type = 'deleteUserFromToolbar';
            deletesuborgObj.organisation = this.props.selectedSubOrg.name;
            dispatch.users.addUserToDelete(deletesuborgObj);
            dispatch.users.userDelModalOpen(true);
        }
    }
    deleteInvitation = async (invite, index, e) => {
        try {
            e.stopPropagation();
            let userdata = invite
            let message = <div className="confirmMessage">
                <h3>Delete invitation</h3>
                <label>{invite.firstName + ' ' + invite.lastName}</label>
                <p>Are you sure that you wish to delete this Invitation?</p>
                <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    await dispatch.invite.deleteInvitaionAsync(userdata);
                    if (userdata.organisationId == userdata.referenceId) {
                        dispatch.initiatives.getInviteBySubOrgAsync(userdata.referenceId)
                    }
                    else {
                        let query = {
                            $sort: { createdAt: 1 },
                            $skip: 0,
                        }
                        let payload = {
                            query: query,
                            organizationId: userdata.organisationId,
                            referenceId: userdata.referenceId
                        };
                        await dispatch.invite.getInvitesAsync(payload);
                    }
                    dispatch.organizationUnit.showResourecePane(null);
                    dispatch.organizationUnit.showDeleteDisabled(false)
                }
            });
        }
        catch (err) {
        }
    }
    async handleClickUserDetailsPage(user, history, e) {
        if (this.props.selectedOrganisation.role === 'workspaceOwner') {
            e.stopPropagation();
            await dispatch.users.updateState(user);
            await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            await dispatch.organizationUnit.showResourecePane(null);
            let ops = "Add Sub-Team"
            dispatch.community.addBreadCrumbOps(ops);
            history.push({
                pathname: `/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/userDetail/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${this.props.match.params.userType}/${user._id}`,
            });
        }
    }
    
    isDeleteDisabled = (user) => {
        return (this.props.isDeleteDisabled || this.props.collapsedResourcePaneIndexTemp === 0 || (this.props.selectedOrganisation.role === 'Manager' && this.props.orgUniqueId === this.props.selectedOrganisation.id) || (user && this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.length > 0 && this.props.selectedAccount.users.some(accuser => accuser.id && accuser.id._id && user._id && accuser.id._id.toString() === user._id.toString() && accuser.role === 'customerAdmin') && this.props.orgUniqueId === this.props.selectedOrganisation.id))
    }
    isInviteDeleteDisabled = (user) => {
        let orgId = this.props.match.url.split("/")
        return (this.props.collapsedResourcePaneIndexTemp === 0 || (this.props.selectedSubOrg && this.props.selectedSubOrg.members ? this.props.selectedOrganisation.role === "Manager" && !this.props.selectedSubOrg.members.some(member => member.role == 'Manager' && member.accountUserId.toString() == user._id.toString()) : this.props.selectedOrganisation.role === "Manager" && orgId[4] === orgId[7]))
    }

    render() {
        let UsersArr = [];
        if (!_.isEmpty(this.props.searchUserQuery)) {
            UsersArr = this.props.searchedUsers[0];
        }
        else if (this.props.usersList && this.props.usersList && this.props.usersList.length > 0) {
            UsersArr = this.props.usersList
        }
        else {
            UsersArr = []
        }

        if (this.props.userRole === 'Invitations' && this.props.invites && this.props.invites.data) {
            UsersArr = this.props.invites && this.props.invites.data;
        }
        return (

            <div className="orgButtonList" >

                <Card.Group>

                    {UsersArr && UsersArr.length > 0 &&
                        UsersArr.map(function (user, index) {
                            return (
                                <Card className={(index === this.props.libraryCardIndex) ? "OrgCard activeCard" : "OrgCard "} raised key={index}
                                    onClick={() => { this.handleClick(user, index) }}
                                    onDoubleClick={() => this.handleDoubleClick(user, index)} >
                                    <div className="pad_5">
                                        <div className="pad_5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ width: '80%' }}>
                                            <ImageAvater user={user} className="f_11 pad_tb_4" />
                                            {this.props.userRole === 'Invitations' ?
                                                <Card.Header style={{ minHeight: "34px" }}>
                                                    < EllipsisTooltip
                                                        name={`${user.firstName} ${user.lastName}`}
                                                        line={2}
                                                        position="top left"
                                                        wide="very"
                                                    />
                                                </Card.Header>
                                                :
                                                <Card.Header style={{ minHeight: "34px", display: 'flex', alignItems: 'center' }} onClick={(e) => { this.handleClickUserDetailsPage(user, this.props.history, e) }}>
                                                    <EllipsisTooltip
                                                        name={`${user.firstName} ${user.lastName}`}
                                                        line={2}
                                                        position="top left"
                                                        wide="very"

                                                    />
                                                </Card.Header>
                                            }
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                            {
                                                this.props.userRole !== 'Invitations' ?
                                                    <Popup className="popupStyled" inverted trigger={<span><button
                                                        style={{ backgroundColor: 'transparent', padding: '2px',color: this.isDeleteDisabled(user) ? '#B9CAD3' : '#FF8F00', cursor: this.isDeleteDisabled(user) ? 'not-allowed' : 'pointer',border:'none',outline:'none',boxShadow:'none' }}
                                                        onClick={(e) => { e.stopPropagation(); this.removeUser(user, index) }}
                                                        disabled={this.isDeleteDisabled(user)}
                                                    ><Icon name='trash'></Icon></button>  </span>}
                                                            content='Delete User'
                                                /> : <Popup className="popupStyled" inverted trigger={<span><button
                                                        style={{ backgroundColor: 'transparent', padding: '2px',color: this.isInviteDeleteDisabled(user) ? '#B9CAD3' : '#FF8F00', cursor: this.isInviteDeleteDisabled(user) ? 'not-allowed' : 'pointer',border:'none',outline:'none',boxShadow:'none' }}
                                                        onClick={(e) => { e.stopPropagation(); this.deleteInvitation(user, index,e) }}
                                                        disabled={this.isInviteDeleteDisabled(user)}
                                                    ><Icon name='trash'></Icon></button>  </span>}
                                                            content='Delete User'
                                                />
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    {user.teamName ?
                                        <Card.Content extra >
                                            <Icon name="user" />
                                            <span>{camelCaseCovert(user.role)}</span><br />
                                            <Icon name='sitemap'></Icon>
                                            <Label circular color="grey" key="color">
                                                {user.subTeamCount}
                                            </Label>
                                        </Card.Content>
                                        :
                                        <Card.Content extra >
                                            <Icon name="user" />
                                            <span>{camelCaseCovert(user.role)}</span><br />
                                            <Icon style={{ color: '#ff9138' }} name='info circle'></Icon> <span className="clr-orange">Invite Sent</span>
                                        </Card.Content>
                                    }

                                </Card>
                            );
                        }, this)}

                    {UsersArr.length === 0 ?
                        <div className="w_50 text-center mar_0_auto pad_20">
                            <Image src={noInvite} /> <br />
                            <strong as="h3" > No users to display.</strong><br /><br />
                            <strong > Communities are all about communicating, <br /> Collaborating and Managing. Start creating your <br />own teams.</strong><br /><br />
                            <Button className="button-submit" onClick={(e) => this.redirectUserInvite(e)} >Add / Invite Users</Button>
                        </div>
                        : ""}

                </Card.Group>
                {this.props.isUserDeactivateModal ?
                    <RemoveUserFromWorkspace {...this.props} /> : ''}

                {this.props.userDelModalOpen ?
                    <DeleteUserFromUnit
                        selectedOrganisation={this.props.selectedOrganisation}
                        selectedAccount={this.props.selectedAccount}
                        userToDel={this.props.userToDel}
                        selectedTeamName={this.props.userToDel.subOrgName}
                        userDelModalOpen={this.props.userDelModalOpen}
                        userObj={this.props.userObj}
                        usersList={this.props.usersList}
                    />
                    : ''}
            </div>
        )
    }
}

export default withRouter(UsersList)